<template>
<div class="max-w-prose">

  <h2
    for="comments"
    class="flex flex-col justify-end text-xl text-gray-800 font-medium sm:text-2xl"
  >
    Success! Your request has been received.
  </h2>

  <p class="mt-2 text-sm text-gray-600">
    You can now sit back, relax, and wait for the responses to come rolling in.
  </p>

  <h3 class="mt-8 text-base text-gray-800 font-semibold">
    What happens next?
  </h3>

  <p class="mt-2 text-sm text-gray-600">
    We will share your request (minus your contact details) with tutors we believe best suit your requirements.
  </p>
  <p class="mt-2 text-sm text-gray-600">
    They will then 
    Tutors who believe they may be able to help will then submit their response back which we will then forward on to you.
    If you like what you see, you can then freely continue to communicate with the tutor and hopefully book in your first session.
  </p>

  <h3 class="mt-8 text-base text-gray-800 font-semibold">
    Meanwhile…
  </h3>

  <p class="mt-2 text-sm text-gray-600">
    Feel free to browse our database of tutors yourself.
  </p>
  
  <button type="button" @click="submit" class="mt-6 self-start inline-flex items-center gap-x-2.5 rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
    Browse tutors
    <svg class="-mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
      <path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z" fill="currentColor" />
    </svg>
  </button>


</div>
</template>

<script>
export default {
  props: {
    enquiry: Object,
  },
  methods: {
    submit() {
      this.$router.push({ 
        name: 'SearchResults', 
        query: { 
          s: this.enquiry.subjectId, 
          l: this.enquiry.levelId,
        } 
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>